module.exports = __webpack_public_path__ + "static/media/dashboard.24527e82.png";